import React, { Component } from 'react';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import Select from 'react-dropdown-select';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';


export class PopupAgreement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            termsAccepted: false
        }

    }

    isFormValid = () => {
        console.log()
        return (
            !this.state.termsAccepted
        );
    }
    handleTermsChange = () => {
        const temp_terms = !this.state.termsAccepted
        this.setState({termsAccepted: temp_terms})
    }

    render() {


        return (
            <Dialog open={true} sx={{
                '& .MuiDialog-paper': {
                    margin: 0,
                },
            }}>
                <DialogTitle>Please Accept Our Terms Before Accessing the Demo</DialogTitle>
                <DialogContent>
                <Typography>To ensure responsible use and protect proprietary data, we require all users to agree to our terms and conditions before exploring the Mapchise demo.</Typography>
                    <div className="margin-x-10">


                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={this.state.termsAccepted}
                                    onChange={this.handleTermsChange}
                                    color="primary"
                                />
                            }
                            label={
                                <Typography variant="body2">
                                    I agree to the{' '}
                                    <Link href="https://mapchise.com/terms-and-conditions/" target="_blank">
                                        Terms
                                    </Link>
                                    {' '}and{' '}
                                    <Link href="https://mapchise.com/privacy" target="_blank">
                                        Privacy Policy
                                    </Link>
                                </Typography>
                            }
                        />

                        {this.state.error_value && (
                            <Typography color="error" className="Competitor-register-error">
                                {this.state.error_value}
                            </Typography>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button 
                        className='color-dark-blue' 
                        onClick={this.props.demoRegisterChange}
                        disabled={this.isFormValid()}
                    >
                        Accept
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}